import cx from 'classnames';

import { getFormattedStackVersion } from '@cloud-wave/neon-common-lib';

import { useConfigContext } from 'lib/core/config';

import { useContactContext } from 'lib/common/contexts/ContactContext';

import usePageProps from 'lib/common/layouts/hooks/usePageProps';

import Text from 'lib/common/components/Text';
import ResponsiveLogo from 'lib/common/components/atoms/ResponsiveLogo';
import AgentStatusTimer from 'lib/common/components/molecules/AgentStatusTimer';

import { getTaskDisplayProps } from 'lib/common/constants/taskStates';

import './softphone-header.scss';

interface ISoftphoneHeaderProps {
  isReversedLayout: boolean;
}

const SoftphoneHeader = ({ isReversedLayout }: ISoftphoneHeaderProps) => {
  const { title: pageTitle } = usePageProps();
  const {
    state: { tasks, selectedTaskId },
  } = useContactContext();
  const { config } = useConfigContext();

  const selectedTask = tasks.find((task) => task.taskId === selectedTaskId);

  const title = pageTitle || getTaskDisplayProps(selectedTask).subtitle;

  return (
    <header className={cx('softphone-header', { 'softphone-header--reversed': isReversedLayout })}>
      <ResponsiveLogo
        isSoftphone
        className="mr-10"
        altText={`${config.BRAND.productName}-version-${getFormattedStackVersion(config.STACK_VERSION).presentation}`}
      />
      {<AgentStatusTimer className="softphone-header__agent-status-timer" />}
      {title && (
        <div className="softphone-header__title" data-testid="softphone-header-title">
          <Text htmlElement="h1" className="softphone-header__title__text" color="darkBlue" type="heading2">
            {title}
          </Text>
        </div>
      )}
    </header>
  );
};

export default SoftphoneHeader;
